// Normalize an error thrown from an axios/fetch call into a user-safe string.
// FastAPI validation errors return `detail` as an array of {loc, msg, type, ...}
// objects; rendering those directly into React state crashes the page.
export function toErrorMessage(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (typeof d === "string" ? d : d?.msg))
      .filter(Boolean);
    return msgs.length ? msgs.join(", ") : fallback;
  }
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return fallback;
}
